import React from 'react'

import { Box, Text } from '@vividseats/vivid-ui-kit'

import { IMAGES } from '@/constants'

import styles from '../styles.module.scss'

const NoExclusions: React.FC = () => (
    <Box
        desktopMarginTop={7}
        desktopMarginBottom={8}
        display="flex"
        align="center"
        justify="center"
        tabletFlexDirection="column"
        mobileFlexDirection="column"
        className={styles.second}
    >
        <Box className={styles.center} desktopPaddingLeft={12}>
            <img
                srcSet={`${IMAGES.REWARDS_NO_EXCLUSIONS_MOBILE} 480w, ${IMAGES.REWARDS_NO_EXCLUSIONS_DESKTOP} 800w`}
                sizes="(max-width: 600px) 300px, 400px"
                src={IMAGES.REWARDS_NO_EXCLUSIONS_DESKTOP}
                alt="no exclusions"
                loading="lazy"
            />
        </Box>
        <Box
            display="flex"
            desktopPaddingLeft={6}
            desktopPaddingTop={12}
            desktopFlexDirection="column"
            tabletFlexDirection="column"
            mobileFlexDirection="column"
            mobilePaddingTop={6}
            className={styles.textBlock}
        >
            <Text as="h2" className={styles.title}>
                No exclusions
            </Text>
            <Box desktopPaddingTop={4} tabletPaddingTop={4} mobilePaddingTop={1} marginBottom={6}>
                <Text>
                    Use your credit on sports, concerts, comedy, theater, and more. With no exclusions, your event
                    options are endless. What’s your 11th?
                </Text>
            </Box>
        </Box>
    </Box>
)

export default NoExclusions
